<div class="schd-a-container">
  @if (loadingDtlsSchdA) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!loadingDtlsSchdA) {

    <button class="btn btn-success btn-sm addBtn" type="button" (click)="addNewRow()">Add New Schedule A</button>

    <table class="table table-bordered form-inline schedule-list-table">
      @for (schdA of form8936SchdADtls; track trackByOccurrence($index, schdA)) {
<tr>
        <td style="width: 36px;">
          <i class="fa fa-minus-circle color-red fa-lg" style="cursor: pointer;" title="Delete" (click)="deleteRow(schdA)"></i>
        </td>
        <td style="width: 36px;">
          <i class="fa fa-pencil bluepencil fa-lg" style="cursor: pointer;" title="Edit" (click)="editRow(schdA)"></i>
        </td>
        @for (subSchA of schdA.OCCURRENCE_DATA; track $index) {
<td>
          {{ subSchA.ATTRIB_DESC }}
          <div>
            <input class="form-control input-md numText"
                   type="text"
                   [ngModel]="subSchA.ATTRIB_VALUE"
                   disabled>
          </div>
        </td>
}
      </tr>
}
    </table>
  
}

  @if (loadingDataSchdA) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (hasEditingTemplate && !loadingDataSchdA) {

    @if (formHeaderSchdA[0]) {
<h4 class="form-title">{{ formHeaderSchdA[0].DESCRIPTION }}</h4>
}

    <table class="table table-bordered form-inline schd-a-table">
      <tbody>
        @for (row of displayedOuter; track trackByLineAttribKey($index, row)) {
<tr class="table1">
          @if (isRegularRow(row)) {
<td>{{ row.LINE_DISP }}</td>
}
          @if (row.ROW_TYPE === 'PH' || row.ROW_TYPE === 'NT') {
<td
              [class.PartHeaderTag]="row.ROW_TYPE === 'PH'">
            <b>{{ row.LINE_DISP }}</b>
          </td>
}

          @if (row.ROW_TYPE === 'PH' || row.ROW_TYPE === 'NT') {
<td
              [class.PartHeaderTag]="row.ROW_TYPE === 'PH'">
            <span><b>{{ row.DESCRIPTION }}</b></span>
          </td>
}
          @if (isRegularRow(row)) {
<td>
            {{ row.DESCRIPTION }}
            @if (row.EDIT_TYPE === 'radio') {
<span style="text-align: left; padding-right: 10px;">
              @for (row1 of getRadioCellsForRow(row.FORM_LINE_KEY); track trackByLineAttribKey($index, row1)) {
<div>
                <label>
                  <input type="checkbox"
                         [checked]="row1.ATTRIB_VALUE === 'true'"
                         (change)="onRadioChange(row1)">
                  {{ row1.ATTRIB_DESCRIPTION }}
                </label>
              </div>
}
            </span>
}
          </td>
}

          @for (row1 of getCellsForRow(row.FORM_LINE_KEY); track trackByLineAttribKey($index, row1)) {
<td
              [hidden]="row.ROW_TYPE === 'PH' || row.ROW_TYPE === 'NT'"
              style="width: 220px;">
            @if (row1.IS_EDITABLE_CELL === 'N' && row1.EDIT_TYPE !== 'radio') {
<div
                 style="text-align: right; padding-right: 10px;"
                 [class.color-red]="row1.ATTRIB_VALUE < 0">
              <span>{{ row1.ATTRIB_VALUE }}</span>
            </div>
}
            @if (row1.IS_EDITABLE_CELL === 'Y'
                       && row1.EDIT_TYPE !== 'checkbox'
                       && row1.EDIT_TYPE !== 'radio'
                       && row1.EDIT_TYPE !== 'custom_date_various'
                       && row1.EDIT_TYPE !== 'dropdown') {
<div
                 style="text-align: right; padding-right: 10px;">
              @if (row1.DATA_TYPE === 'number' || row1.DATA_TYPE === 'decimal' || row1.DATA_TYPE === 'string') {
<input
                     class="form-control input-md numText"
                     style="text-align: right" type="text"
                     [ngModel]="row1.ATTRIB_VALUE"
                     (ngModelChange)="onFieldChange(row1, $event)">
}
            </div>
}
            @if (row1.EDIT_TYPE === 'checkbox') {
<div style="padding-left: 25px;">
              <input type="checkbox"
                     [checked]="row1.ATTRIB_VALUE === 'true'"
                     (change)="onCheckboxChange(row1, $event)">
            </div>
}
            @if (row1.EDIT_TYPE === 'custom_date_various') {
<div style="padding-left: 25px;">
              <gtw-credits-date-various
                [row]="row1"
                (changed)="onDateVariousChange(row1)">
              </gtw-credits-date-various>
            </div>
}
          </td>
}
        </tr>
}
      </tbody>
    </table>
  
}

  <!--
    Footer mirrors the legacy Schedule A template: Save/Reset operate on the
    currently-edited vehicle and are disabled when no editing template is
    active; Cancel always closes the modal (delegated to the parent via the
    `cancel` output). This is the only set of buttons shown while on the
    Schedule A tab; the parent's modal-footer is hidden in that mode.
  -->
  <div class="schd-a-footer">
    <button class="save-button" type="button"
            [disabled]="!hasEditingTemplate || isSaveClickedSchdA"
            (click)="saveSchdA()">
      @if (isSaveClickedSchdA) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
    </button>
    <button class="reset-button" type="button"
            [disabled]="!hasEditingTemplate"
            (click)="resetSchdA()">Reset</button>
    <button class="cancel-button" type="button" (click)="cancelFormSchdA()">Cancel</button>
  </div>
</div>
